/*
  Name Drop archive — INDO-17. Used by sections/name-drop-archive.liquid.

  <name-drop-index> does two things, and the page works without either:
  - Past `data-visible` names, collapses the chips and offers "Show all N names",
    which swaps the chips for the full numbered list. Without this script every
    chip stays visible.
  - When a name is picked, moves focus to that drop's heading, so keyboard and
    screen-reader users land where they meant to go rather than back at the index.
*/

if (!customElements.get('name-drop-index')) {
  class NameDropIndex extends HTMLElement {
    connectedCallback() {
      this.visible = parseInt(this.dataset.visible, 10) || 12;
      this.count = parseInt(this.dataset.count, 10) || 0;
      this.chips = this.querySelector('.nda-index__chips');
      this.list = this.querySelector('.nda-index__list-wrap');
      this.openButton = this.querySelector('[data-index-open]');
      this.closeButton = this.querySelector('[data-index-close]');

      if (this.list && this.openButton && this.count > this.visible) {
        this.collapseChips();
        this.openButton.hidden = false;
        this.openButton.addEventListener('click', () => this.setOpen(true));
        this.closeButton?.addEventListener('click', () => this.setOpen(false));
      }

      this.addEventListener('click', (event) => this.onLinkClick(event));
    }

    collapseChips() {
      this.chips.querySelectorAll('[data-position]').forEach((item) => {
        item.hidden = parseInt(item.dataset.position, 10) >= this.visible;
      });
    }

    setOpen(open) {
      this.chips.hidden = open;
      this.list.hidden = !open;
      this.openButton.setAttribute('aria-expanded', String(open));
      (open ? this.list.querySelector('a') : this.openButton)?.focus();
    }

    onLinkClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      const heading = target?.querySelector('h2[tabindex="-1"]');
      if (!heading) return;

      // Let the browser do the (smooth) scroll and update the URL; only move focus.
      requestAnimationFrame(() => heading.focus({ preventScroll: true }));
    }
  }

  customElements.define('name-drop-index', NameDropIndex);
}
